import { KSpan } from "kahuna-base-react-components"
import React from "react"
import { lang } from "../../../../constants/languages"

const AnalysisListComponent = ({ i, row, platform }) => {

  const divHeight = 48 

  const formatQuantity = (quantity: number): string => {
    if (Math.abs(quantity) < 1000) {
      return `${quantity}`
    } else if (Math.abs(quantity) >= 1000 && Math.abs(quantity) < 1000000) {
      return `${(quantity / 1000).toFixed(1)}K`
    } else if (Math.abs(quantity) >= 1000000 && Math.abs(quantity) < 1000000000) {
      return `${(quantity / 1000000).toFixed(1)}M`
    } else {
      return `${(quantity / 1000000000).toFixed(1)}B`
    }
  }

  const renderReleaseCover = () => {
    const cover = platform === "youtube" ? "/account_icons/social_media_icons/youtube.svg" : row.releaseCover

    return (
      <img
        width={48}
        height={48}
        src={cover}
        style={{
          borderRadius: 6,
          boxShadow: "0px 16px 32px -12px rgba(88, 92, 95, 0.10)"
        }}
      />
    )
  }

  return (
    <li key={`data-row-${i}`}>
      <div className={`rounded-lg p-[16px] gap-[20px] h-[80px] hover:bg-[#F7F7F7] !border-none table-row-hover`}>
        <div className={`h-[${divHeight}px] flex flex-row justify-between items-center `}>
          <div className="w-[60%] flex flex-row justify-start items-center">
            <div className="flex items-center">
              <div className="shrink-0" style={{ marginRight: 16 }}>{renderReleaseCover()}</div>
              <div className="flex flex-col justify-center">
                <KSpan text={row.track} color="#111" fontWeight={500} fontSize={16} lineHeight="24px" />
                {row.artistList?.length > 0 && (
                  <KSpan
                    text={row.artistList.map((artist) => artist.name).join(", ")}
                    fontWeight={400}
                    lineHeight="24px"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="w-[20%] flex flex-row justify-center items-center gap-1">
            <img src="/analytics_icons/album-record.svg" alt="album-record-icon" />
            <KSpan
              text={`${formatQuantity(row.quantity)}`}
              color="#111"
              fontWeight={500}
              letterSpacing="-0.176px"
              fontSize={14}
            />
          </div>
          <div className="w-[20%] flex flex-row justify-center items-center gap-1">
             <img src={ row.changeQuantity > 0 ? "/analytics_icons/caret-up-v3.svg" :  "/analytics_icons/caret-down-v3.svg" } alt="album-record-icon" />

            <KSpan
              text={`${row.changeQuantity > 0 ? "+" : ""}${formatQuantity(row.changeQuantity)}`}
              color={row.changeQuantity > 0 ? "#56E099" : "#FF5865"}
              fontWeight={500}
              letterSpacing="-0.176px"
              fontSize={14}
            />
          </div>
        </div>
      </div>
    </li>
  )
}

export default AnalysisListComponent
